module.exports = __webpack_public_path__ + "img/grau-david@2x.17f9caad.png";